export default "January 14, 2023";